<template>
  <div id="app">
     <router-view/>
  </div>
</template>
<script>
import DevicePixelRatio from './utils/devicePixelRatio';

export default {
  name: "App",
  created() {
    new DevicePixelRatio().init();
  },
  components: {

  }
};
</script>
<style>

</style>